const progressCorrespondence = {
    template: require('./correspondence.html'),
    bindings: {
        analytics: '<',
        endDate: '<',
        inCoaching: '<',
        startDate: '<',
    },
};

export default angular
    .module('mpdx.coaches.show.progress.correspondence', [])
    .component('coachesShowProgressCorrespondence', progressCorrespondence).name;
